"use strict";
function initFileUpload(input) {
    const inputId = input.id;
    const fileListElement = document.querySelector('#fileList_' + inputId);
    let filesList = [];
    input.addEventListener('change', () => {
        if (input.files?.length) {
            if (!input.multiple) {
                filesList = [];
            }
            for (let index = 0; index < input.files.length; index++) {
                filesList.push(input.files[index]);
            }
            updateFileInput();
            renderFileList();
        }
    });
    function renderFileList() {
        if (!fileListElement) {
            return;
        }
        fileListElement.innerHTML = '';
        filesList.forEach((file, index) => {
            const li = document.createElement('li');
            li.classList.add('spv-uploadedFileContainer');
            const fileName = document.createElement('p');
            fileName.textContent = 'Valgt fil: ' + file.name;
            const removeButton = document.createElement('button');
            removeButton.setAttribute('aria-label', 'Fjern filen');
            removeButton.setAttribute('id', `${fileName}-remove-button`);
            removeButton.setAttribute('type', `button`);
            removeButton.classList.add('spv-removeButton');
            removeButton.addEventListener('click', () => {
                removeFile(index);
            });
            li.appendChild(fileName);
            li.appendChild(removeButton);
            fileListElement.appendChild(li);
        });
    }
    function updateFileInput() {
        const dataTransfer = new DataTransfer();
        filesList.forEach(file => dataTransfer.items.add(file));
        input.files = dataTransfer.files;
    }
    function removeFile(index) {
        filesList.splice(index, 1);
        updateFileInput();
        renderFileList();
    }
}
window.addEventListener('DOMContentLoaded', () => {
    console.debug('DOMContentLoaded fileupload');
    const fileUploads = document.querySelectorAll('input.spv-fileUpload');
    fileUploads.forEach((input) => initFileUpload(input));
});
//# sourceMappingURL=fileupload.js.map